import styled from 'styled-components'
import Overlay from 'common/Overlay'
import { UniversalPortal } from '@jesstelford/react-portal-universal'
import { Typography } from 'common/typography'
import { MdClose } from 'react-icons/md'
import { TransparentButton } from 'common/button'
import { customScrollBar } from 'common/scroll-bar'
import data from './points-explanation.json'

const PodiumModalStyled = styled.div`
  height: 100vh;
  position: relative;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  .points-modal {
    position: relative;
    background: var(--neutral90);
    color: var(--white);
    max-inline-size: 580px;
    border-radius: 8px;
    overflow: hidden;
  }
  .points-container {
    box-sizing: border-box;
    max-height: 80vh;
    padding: 16px;
    overflow: auto;
    ${customScrollBar}
  }
  .points-title {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    margin-block-end: 8px;
    button {
      position: absolute;
      right: 24px;
    }
  }
  .points-item {
    margin-block-start: 24px;
    display: flex;
    gap: 8px;
    &-description {
      margin-block-start: 4px;
      margin-block-end: 4px;
    }
  }
  @media(min-width: 768px) {
    .points-modal {
      max-height: 700px;
    }
    .points-container {
      padding: 40px;
      max-height: 700px;
    }
  }
`

function PodiumModal({ points, setPoints }) {

  const closeModal = (e) => {
    if (e.target.id === 'overlay' || e.target.parentElement.id === 'overlay') {
      setPoints(false)
    }
  }

  return (
    <>
      <UniversalPortal selector="#page-portal">
        {points ? (
          <Overlay zIndex={5} onClick={closeModal}>
            <PodiumModalStyled>
              <div className="points-modal">
                <div className="points-container">
                  <div className="points-title">
                    <Typography small="headline6" large="headline5">
                      ¿Cómo ganar puntos?
                    </Typography>
                    <TransparentButton onClick={() => setPoints(false)}>
                      <MdClose size={24} />
                    </TransparentButton>
                  </div>
                  <Typography>
                    Dale seguimiento a tu aprendizaje y al de la comunidad, comprueba que tanto estás avanzando y mejora tu progreso con el sistema de puntos que tenemos para ti.
                  </Typography>
                  <ul className="points">
                    {data.map(({ title, description, image, points }) => (
                      <li className="points-item">
                        <div>
                          <img className="points-item-img" src={image} alt={title} width="56" height="56" />
                        </div>
                        <div>
                          <Typography font="p2Bold" large="regularBold">{title}</Typography>
                          <Typography className="points-item-description">{description}</Typography>
                          <Typography font="p2Bold" large="regularBold" color="var(--lightBlue)">{points}</Typography>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </PodiumModalStyled>
          </Overlay>
        ) : null}
      </UniversalPortal>
    </>
  )
}

export default PodiumModal
